export const FOOTER_ITEMS_KCELL = [
	{ ru: 'Акции', kk: 'Науқандар', href: (lang) => `https://www.kcell.kz/${lang}/promo` },
	{ ru: 'Частые вопросы', kk: 'Жиі сұрақтар', href: (lang) => `https://www.kcell.kz/${lang}/faq` },
	{ ru: 'Настройки', kk: 'Баптаулар', href: (lang) => `https://www.kcell.kz/${lang}/settings` },
	{ ru: 'Контакты', kk: 'Байланыстар', href: (lang) => `https://www.kcell.kz/${lang}/contacts/phones` },
	{ ru: 'О компании', kk: 'Компания туралы', href: (lang) => `https://www.kcell.kz/${lang}/about` },
	{ ru: 'Работа в Kcell', kk: 'Kcell-дегі жұмыс', href: (lang) => `https://jobs.kcell.kz/${lang}` },
	{ ru: 'Новости', kk: 'Жаңалықтар', href: (lang) => `https://www.kcell.kz/${lang}/news` },
	{ ru: 'Пресс-релизы', kk: 'Баспасөз-релиздері', href: (lang) => `https://www.kcell.kz/${lang}/press-releases` },
	{ ru: 'Закупки', kk: 'Сатып алулар', href: (lang) => `https://www.kcell.kz/${lang}/purchases` },
	{ ru: 'Офисы', kk: 'Кеңселер', href: (lang) => `https://www.kcell.kz/${lang}/contacts` },
	{
		ru: 'Политика конфиденциальности',
		kk: 'Құпиялылық саясаты',
		href: (lang) => lang === 'ru' ?
			'https://www.kcell.kz/uploads/2022/4/27/5e09a07e87c6fa9a19d0d2e050206471_original.639742.pdf' :
			'https://www.kcell.kz/uploads/2022/4/27/cc832913d0735718de69a262e00dae4c_original.215801.pdf'
	},
]

export const FOOTER_ITEMS_ACTIV = [
	{ ru: 'Акции', kk: 'Науқандар', href: (lang) => `https://activ.kz/${lang}/promo` },
	{ ru: 'Частые вопросы', kk: 'Жиі сұрақтар', href: (lang) => `https://activ.kz/${lang}/faq` },
	{ ru: 'Настройки', kk: 'Баптаулар', href: (lang) => `https://activ.kz/${lang}/settings` },
	{ ru: 'Контакты', kk: 'Байланыстар', href: (lang) => `https://activ.kz/${lang}/contacts/phones` },
	{ ru: 'О компании', kk: 'Компания туралы', href: (lang) => `https://activ.kz/${lang}/about` },
	{ ru: 'Работа в Kcell', kk: 'Kcell-дегі жұмыс', href: (lang) => `https://jobs.kcell.kz/${lang}` },
	{ ru: 'Новости', kk: 'Жаңалықтар', href: (lang) => `https://activ.kz/${lang}/news` },
	{ ru: 'Пресс-релизы', kk: 'Баспасөз-релиздері', href: (lang) => `https://www.activ.kz/${lang}/press-releases` },
	{ ru: 'Закупки', kk: 'Сатып алулар', href: (lang) => `https://activ.kz/${lang}/purchases` },
	{ ru: 'Офисы', kk: 'Кеңселер', href: (lang) => `https://activ.kz/${lang}/contacts` },
	{
		ru: 'Политика конфиденциальности',
		kk: 'Құпиялылық саясаты',
		href: (lang) => lang === 'ru' ?
			'https://activ.kz/uploads/2022/4/27/5e09a07e87c6fa9a19d0d2e050206471_original.639742.pdf' :
			'https://activ.kz/uploads/2022/4/27/cc832913d0735718de69a262e00dae4c_original.215801.pdf'
	},
]

export const Message = {
	mainTitle: {
		ru: 'Невозможно загрузить страницу',
		kk: 'Бетті жүктеу мүмкін емес',
	},
	mainSubtitle: {
		ru: 'Трафик на Вашем номере полностью исчерпан. Выберите Ваш бренд',
		kk: 'Нөміріңіздегі трафик толықтай таусылды. Брендіңізді таңдаңыз',
	},
	serviceTitle: {
		ru: 'Выберите услугу',
		kk: 'Қызметті таңдаңыз',
	},
	serviceInternetPackage: {
		ru: 'Подключить интернет пакет',
		kk: 'Интернет топтаманы қосу',
	},
	serviceReconnect: {
		ru: 'Переподключить тариф',
		kk: 'Тарифті қайта қосу',
	},
	serviceChange: {
		ru: 'Сменить тариф',
		kk: 'Тарифті ауыстыру',
	},
	serviceExtra: {
		ru: 'Экстра услуги',
		kk: 'Экстра қызметтер',
	},
	serviceExtraBack: {
		ru: 'Вернуться назад',
		kk: 'Кері қайту',
	},
	serviceExtraTitle: {
		ru: 'Возьмите сейчас, а оплатите через 5 дней',
		kk: 'Қазір алып, 5 күннен кейін төлеңіз',
	},
	serviceExtraMb: {
		ru: 'Экстра мегабайты',
		kk: 'Экстра мегабайттар',
	},
	serviceExtraBalance: {
		ru: 'Экстра баланс',
		kk: 'Экстра теңгерім',
	},
	auletTitle: {
		ru: 'Ежемесячный трафик по пакету «Годовой Аулет» закончился',
		kk: 'Жылдық Аулет пакеті бойынша ай сайынғы трафик аяқталды.',
	},
	auletSubtitle: {
		ru: 'Вы можете подключить дополнительный пакет, который включает до 500ГБ Интернет-трафика. Пользуйтесь интернетом на максимальной скорости до конца срока действия подключенного пакета',
		kk: 'Сіз 500 Гб дейінгі Интернет-трафикті қамтитын қосымша пакетті қосуға болады. Қосылған пакеттің жарамдылық мерзімінің соңына дейін Интернетті максималды жылдамдықпен пайдаланыңыз',
	},
	signIn: {
		ru: 'Войти в личный кабинет',
		kk: 'Жеке кабинетке кіру'
	},
}
